import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import OnBoardingCreate from './views/OnBoardingCreate.vue'
import OnBoardingEdit from './views/OnBoardingEdit.vue'
import OnBoardingList from './views/OnBoardingList.vue'
import EmployeesList from './views/EmployeesList.vue'
import LoginPage from './views/LoginPage.vue'
import BillboardPage from './views/BillboardPage.vue'
import BillboardCreatePage from './views/BillboardCreatePage.vue'
import BillboardEditPage from './views/BillboardEditPage.vue'
import Error404 from './views/pages/error/ErrorNotFound.vue'
import Error404H from './views/pages/error/Error404.vue'
import Error404NotHeader from './views/pages/error/ErrorNotFoundNotHeader.vue'
import Error403 from './views/pages/error/Error403.vue'
import MainDocumentPage from './views/MainDocumentPage.vue'
import store from '@/vuex/store'
import axios from 'axios'
import Auth from "./apiClient/Auth"
import FoldersModule from '@/modules/Folders/router'
import EmployeesModule from '@/modules/Employees/router'
import MainBusinessPage from './views/MainBusinessPage.vue'
import UpdateLogo from './views/UpdateLogo.vue'
import UpdateColors from './views/UpdateColors.vue'
import SelfServiceModule from '@/modules/SelfService/router'
import CompanyModule from '@/modules/Company/router'
import CustomEmailsModule from './modules/CustomEmails/router'
import Reports from '@/modules/Reports/router'
import DocumentsPublishModule from '@/modules/Documents/publish/router'
import DocumentsDetailModule from '@/modules/Documents/detail/router'
import WorkflowModule from '@/modules/Workflow/router'
import managerModule from '@/modules/ManagerManagement/router'
import { isEmpty } from 'lodash'

const auth = new Auth()
Vue.use(Router)

function loadView(view) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`)
}
function loadComponent(dir, component) {
  return () => import(`@/components/${dir}/${component}.vue`)
}

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_BASE,
  routes: [
    {
      path: '/',
      redirect: '/home',
      name: 'homedefault',
      component: loadView('Home'),
      meta: {
        requiresAuth: true,
        requiresPermission: false,
      },
    },
    {
      path: '/login',
      name: 'login',
      component: loadView('LoginPage'),
      meta: {
          requiresAuth: false,
          requiresPermission: false,
          plainLayout: true
      },
      beforeEnter: async (to, from, next) => {
        try {
          const { ssoToken } = to.query
          if(ssoToken) {
            to.query.ssoToken = ''
            await redirectAuthSSO(next, ssoToken)
          } else {
            next()
          }
        } catch (e) {}
      }
    },
    {
      path: '/redirect',
      name: 'redirect',
      component: loadView('Redirect'),
      meta: {
          requiresAuth: true,
          requiresPermission: false
      }
    },
    {
      path: '/home/',
      name: 'home',
      component: loadView('Home'),
      meta: {
          requiresAuth: true,
          requiresPermission: false
      },
      beforeEnter: (to, from, next) => {
        window.location.href = window.origin + '/v3/dashboard'
        next(false)
      },
    },
    {
      path: '/MainDocumentPage',
      name: 'MainDocumentPage',
      component: loadView('MainDocumentPage'),
      meta: {
          requiresAuth: true,
          requiresPermission: false
      }
    },
    {
      path: '/MainBusinessPage',
      name: 'MainBusinessPage',
      component: loadView('MainBusinessPage'),
      meta: {
          requiresAuth: true,
          requiresPermission: false
      }
    },
    {
	    path: '/pickup',
	    name: 'pickup',
	    component: loadView('Pickup'),
	    meta: {
	        requiresAuth: true,
	        requiresPermission: true,
	        action: 62
	    }
     },
    {
      path: '/onboarding/create',
      name: 'obcreate',
      component: loadView('OnBoardingCreate'),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        action: 73
      }
    },
    {
      path: '/onboarding/edit/:id',
      name: 'obedit',
      component: loadView('OnBoardingEdit'),
      meta: {
          requiresAuth: true,
          requiresPermission: true,
          action: 74
      }
    },
    {
      path: '/onboarding/list',
      name: 'oblist',
      component: loadView('OnBoardingList'),
      meta: {
          requiresAuth: true,
          requiresPermission: true,
          action: 73
      }
    },
    { 
      path: '/employees/list',
      name: 'employeeslist',
      component: loadView('EmployeesList'),
      meta: {
          requiresAuth: true,
          requiresPermission: true,
          action: 7
      }
    },
    {
      path: '/employees/unsubscribe',
      name: 'unsubscribe',
      component: loadView('Unsubscribe'),
      meta: {
          requiresAuth: true,
          requiresPermission: true,
          action: 7
      },
      beforeEnter: async (to, from, next) => {
        await store.dispatch('setPeopleOnboardingStatus')
        const hasVPIntegration = store.getters.getPeopleOnboarding
        const noOnBoardingPerm = !store.getters.isActionAllowed(73) && !store.getters.isActionAllowed(74)  
        if (hasVPIntegration && noOnBoardingPerm) {
          next({ path: '/403' })
          return
        }
        next()
      },
    },
    {
        path: '/employee/:id',
        name: 'employee',
        component: loadView('UsuarioAMView'),
        meta: {
            requiresAuth: true,
            requiresPermission: true,
            action: 7
        }
    },
    {
      path: '/billboard',
      name: 'billboard',
      component: loadView('BillboardPage'),
      meta: {
          requiresAuth: true,
          requiresPermission: true,
          action: 44
      }
    },
    {
        path: '/billboard/create',
        name: 'billboardcreate',
        component: loadView('BillboardCreatePage'),
        meta: {
            requiresAuth: true,
            requiresPermission: true,
            action: 44
        }
    },
    {
        path: '/billboard/edit/:id',
        name: 'billboardedit',
        component: loadView('BillboardEditPage'),
        props: { id: true },
        meta: {
            requiresAuth: true,
            requiresPermission: true,
            action: 44
        }
    },
    {
      path: '/fileUploadResume',
      name: 'fileUploadResume',
      component: loadView('fileUploadPage'),
      beforeEnter: (to, from, next) => {
        if(store.getters.isActionAllowed(305)) {
          window.location.href = window.origin + '/v3/tasks-manager'
          next(false)
          return 
        }
        next()
      },
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        action: 78,
      },
    },
    {
      path: '/publishedEforms',
      name: 'publishedEforms',
      component: loadView('publishedEformsPage'),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        action: 62,
      },
    },
    ...CustomEmailsModule,
    ...FoldersModule,
    ...EmployeesModule,
    ...SelfServiceModule,
    ...CompanyModule,
    ...Reports,
    ...WorkflowModule,
    ...managerModule,
    {
      path: '/certificates',
      name: 'certificates',
      component: loadView('CertificatesPage'),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        action: 104,
      },
    },
    {
      path: '/documents',
      name: 'documents',
      component: loadView('Documents'),
      meta: {
        requiresAuth: true,
      },
      children: [
        ...DocumentsPublishModule,
        ...DocumentsDetailModule,
        {
          name: 'massive-post',
          path: 'publish/massive',
          component: loadComponent('documents/publish', 'Massive'),
          meta: {
            requiresAuth: true,
            requiresPermission: true,
            action: 105,
          },
        },
      ],
    },
    {
      path: '/documents/search',
      name: 'documentSearch',
      component: loadView('DocumentSearch'),
      meta: {
        requiresAuth: true,
        action: 3,
        requiresPermission: true,
      },
    },
    {
      path: '/generalSettings',
      name: 'generalSettings',
      component: loadView('Settings'),
      meta: {
        requiresAuth: true,
        requiresPermission: false,
      },
    },
    {
      name: 'update-logo',
      path: '/update/logo',
      component: loadView('UpdateLogo'),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        action: 109,
      },
    },
    {
      name: 'update-colors',
      path: '/update/colors',
      component: loadView('UpdateColors'),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        action: 109,
      },
    },
    {
      path: '/404NH/',
      name: '404NH',
      component: Error404NotHeader,
      meta: {
        requiresAuth: true,
        requiresPermission: false,
        plainLayout: true,
      },
    },
    {
      path: '/404H/',
      name: '404H',
      component: Error404H,
      meta: {
        requiresAuth: true,
        requiresPermission: false,
      },
    },
    {
      path: '/404/',
      name: '404',
      component: Error404,
      meta: {
        requiresAuth: true,
        requiresPermission: false,
      },
    },
    {
      path: '/403/',
      name: '403',
      component: Error403,
      meta: {
        requiresAuth: true,
        requiresPermission: false,
      },
    },
    {
	    path: '*',
	    redirect: '/404NH/'
	  },
    {
      path: '/redirect/authSSO/',
      name: 'authSSO',
      component: loadComponent('login/sso', 'authSSO'),
      meta: {
        requiresAuth: false,
        requiresPermission: false,
        plainLayout: true
      }
    },
    {
      path: '/redirect/auth-token/',
      name: 'authTokenEntry',
      component: loadComponent('login/tokenEntry', 'authTokenEntry'),
      meta: {
        requiresAuth: false,
        requiresPermission: false,
        plainLayout: true
      }
    },
    {
      path: '/:company',
      name: 'company',
      beforeEnter: async (to, from, next) => {
        const company = to.path.substring(1)
        try{
          const response = await auth.loginCustomFile(company)
          if(response.data.loginCustom.admin) {
            const sso = response.data.loginCustom.admin.sso.showButton
            let ssoData = {
              sso: sso,
              company: company
            }
            await store.dispatch('setSSOData', ssoData);
            localStorage.setItem('ssoData', JSON.stringify(ssoData))
            next('/login')
          }else{
            next('/login')
          }
        }catch(e){
          localStorage.removeItem('ssoData')
          await store.dispatch('setSSOData', {})
          next('/login')
        }
      }
    },

  ]
});

router.beforeEach(async (to, from, next) => {
  // Restore session from localStorage to store if necessary
  // Guard against localStorage.jwt being the literal string "null"
  const rawJwt = localStorage.jwt
  const validJwt = rawJwt && rawJwt !== 'null' && rawJwt !== 'undefined'
  if (isEmpty(store.getters.getToken) && validJwt) {
    await store.dispatch('setJwt', { token: rawJwt })
  }

  // Restore user from localStorage to store if necessary
  if ((!store.getters.getUser || isEmpty(store.getters.getUser.id)) && !isEmpty(localStorage.user)) {
    try {
      const parsedUser = JSON.parse(localStorage.user)
      if (parsedUser) {
        await store.dispatch('setUser', { user: parsedUser })
      }
    } catch (e) {
      console.error("Error restoring user from localStorage", e)
    }
  }

  // Restore or fetch actions/permissions
  if (to.name !== 'login' && !to.meta.plainLayout && (!store.state.permissions || store.state.permissions.length === 0)) {
    const cachedActions = localStorage.getItem('actions')
    if (cachedActions) {
      try {
        const parsed = JSON.parse(cachedActions)
        const res = parsed.status === 200 ? parsed.data.results.data : (parsed.results?.data || [])
        const fil = res.map((n: any) => Number(n.id))
        await store.dispatch('setPermissions', { permissions: fil })
      } catch (e) {
        console.error("Error restoring permissions", e)
      }
    }

    // Fallback: try to restore from the persisted Vuex store (vuex-onboarding key)
    if (!store.state.permissions || store.state.permissions.length === 0) {
      try {
        const persistedVuex = localStorage.getItem('vuex-onboarding')
        if (persistedVuex) {
          const parsed = JSON.parse(persistedVuex)
          if (Array.isArray(parsed.permissions) && parsed.permissions.length > 0) {
            await store.dispatch('setPermissions', { permissions: parsed.permissions })
          }
        }
      } catch (e) {
        console.error("Error restoring permissions from vuex-onboarding", e)
      }
    }

    // If still empty and we have a valid token, call the API directly to fetch them
    if ((!store.state.permissions || store.state.permissions.length === 0) && !isEmpty(store.getters.getToken)) {
      try {
        await store.dispatch('setInitialMenu')
      } catch (e) {
        const err = e as any
        console.error("Error fetching permissions in router", err)
        if (err?.response && err.response.status === 401) {
          localStorage.removeItem('jwt')
          localStorage.removeItem('user')
          localStorage.removeItem('actions')
          localStorage.removeItem('vuex')
          store.dispatch('setJwtExpired', { jwtExpired: true })
          if (to.name !== 'login') {
            return next('/login')
          }
        }
      }
    }
  }

  store.dispatch('setValidateSection', { validateSection: to.meta.requiresAuth })

  if (to.name != 'login' && store.getters.getUser && store.getters.getUser.ingreso === 0) {
    return next('/login')
  }

  if (
    !isEmpty(localStorage.jwt) &&
    store.getters.getToken !== null &&
    store.getters.getJwtExpired !== true &&
    to.name == 'login'
  ) {
    return next('/home')
  }

  if (
    isEmpty(store.getters.getToken) &&
    to.name !== 'login' &&
    to.name !== '404NH' &&
    to.name !== 'company' &&
    to.name !== 'authSSO' &&
    to.name !== 'authTokenEntry'
  ) {
    await store.dispatch('setHistoryUrl', { historyUrl: to.name })
    return next('/login')
  }

  if (
    !isEmpty(localStorage.jwt) &&
    !isEmpty(store.getters.getToken) &&
    store.getters.getJwtExpired !== true &&
    !isEmpty(store.getters.getHistoryUrl)
  ) {
    let history = store.getters.getHistoryUrl
    await store.dispatch('setHistoryUrl', { historyUrl: null })
    return next({ name: history })
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (to.matched.some((record) => record.meta.requiresPermission)) {
      if (!store.state.permissions) {
        return next('/403')
      } else if (store.state.permissions.length > 0) {
        if (!store.state.permissions.includes(to.meta.action)) {
          return next('/403')
        } else {
          store.dispatch('setInitialCountry')
          return next()
        }
      } else {
        if (store.getters.getToken == null || store.getters.getToken == '') {
          return next('/login')
        } else if (store.getters.getJwtExpired === true) {
          return next('/login')
        } else {
          return next('/403')
        }
      }
    }
  }

  return next()
})
const redirectAuthSSO = (next, ssoToken) => {
  try {
    next({name: 'authSSO', params: { ssoToken: ssoToken } })
  } catch (e) {
    next()
  }
}

export default router
